module.exports = __webpack_public_path__ + "img/p6.c21fd0a1.png";